import { render, staticRenderFns } from "./scaleBoxVertical.vue?vue&type=template&id=3494a603&scoped=true&"
import script from "./scaleBoxVertical.vue?vue&type=script&lang=js&"
export * from "./scaleBoxVertical.vue?vue&type=script&lang=js&"
import style0 from "./scaleBoxVertical.vue?vue&type=style&index=0&id=3494a603&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3494a603",
  null
  
)

export default component.exports